import React, {useMemo} from 'react';
import {useHeaderHeight} from '@react-navigation/elements';
import {observer} from 'mobx-react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {useScrollCollapseReset} from '../../hooks/useScrollCollapse';
import {Department} from '../../models/middleware';

type RangeSubDepartmentsScreenProps = {
  department: Department;
  subDepartments: Department[];
  onSubDepartmentPress: (subDepartment: Department) => void;
};

const RangeSubDepartmentsScreen = observer(
  ({subDepartments, onSubDepartmentPress}: RangeSubDepartmentsScreenProps) => {
    // DIS-1127: DEPARTMENT route uses headerTransparent:true, so the screen
    // starts at y=0 under the header. Compensate by adding paddingTop inside
    // the FlatList content (not on the outer container) so items scroll away
    // under the collapsing header naturally.
    const headerHeight = useHeaderHeight();
    const contentContainerStyle = useMemo(() => ({paddingTop: headerHeight}), [headerHeight]);

    // DIS-1127 regression fix: this screen has no scroll handler of its own,
    // so without this reset ctx.scrollY retains the previous screen's value
    // (e.g. a scrolled Shop tab) and the AnimatedHeader renders collapsed
    // off-screen, leaving a white header gap.
    useScrollCollapseReset();

    return (
      <ContentView testID="shop-subdepartment-screen">
        <FlatListMenu
          data={subDepartments}
          onPressItem={onSubDepartmentPress}
          contentContainerStyle={contentContainerStyle}
        />
      </ContentView>
    );
  },
);

export default RangeSubDepartmentsScreen;
